import React from 'react';
import { useDispatch } from 'react-redux';
import Users from './components/users';
import { setGetMailingStatisticsScrollerUsersTransactions } from '../../../../../store/mailing/thunk/setGetMailingStatisticsScrollerUsersTransactions';

const CountUsersDeposits = ({
    id
}) => {

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetMailingStatisticsScrollerUsersTransactions({
            mailing_id: id,
            page: 1,
            pageSize: 25
        }))
    }, [])

    return (
        <div>
            <div>
                <h3 style={{
                    color: "#FFFFFF",
                    fontWeight: 700,
                }}>Пользователи с транзакциями без оплаты</h3>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Users mailing_id={id} />
            </div>
        </div >
    )
}

export default CountUsersDeposits;